import React from 'react';
import classNames from 'classnames';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useGetEnvQuery } from '../../../../services/system';
import './EnvironmentBadge.scss';

export interface EnvironmentBadgeProps {
  visible: boolean;
  className?: string;
}

type EnvKind = 'prod' | 'dev';

const resolveEnvKind = (raw: string | undefined): EnvKind =>
  raw?.toLowerCase().startsWith('prod') ? 'prod' : 'dev';

const ENV_LABEL: Record<EnvKind, string> = {
  prod: 'PROD',
  dev: 'DEV',
};

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  visible,
  className,
}) => {
  const { data, isLoading, isError } = useGetEnvQuery();

  if (!visible) {
    return null;
  }

  const kind: EnvKind = resolveEnvKind(data);
  const value = isLoading ? '…' : isError ? '—' : ENV_LABEL[kind];

  return (
    <Box
      className={classNames(
        'environment-badge',
        `environment-badge--${kind}`,
        className,
      )}
    >
      <Flex className='environment-badge__row'>
        <Text className='environment-badge__title'>Environment</Text>
        <Text className='environment-badge__value'>{value}</Text>
      </Flex>
    </Box>
  );
};

export default EnvironmentBadge;
